import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { TermsOfServicesComponent } from './pages/systemPages/terms-of-services.component';
import { PrivacyPolicyComponent } from './pages/systemPages/privacy-policy.component';
import { AuthenticateComponent } from './pages/authenticate/authenticate.component';
import { appGuard, mixedGuard } from './app.guard';
import { SearchComponent } from './pages/listing/search.component';
import { ManageAccountPageComponent } from './pages/account/manage-account.page';
import { PhotosComponent } from './pages/manage-listing/photos.component';
import { DetailsComponent } from './pages/manage-listing/details.component';
import { PriceStockComponent } from './pages/manage-listing/price-stock.component';
import { DeliveryComponent } from './pages/manage-listing/delivery.component';
import { StatusComponent } from './pages/manage-listing/status.component';
import { ManageUsersComponent } from './pages/account/manage-users.component';
import { EmailVerifiedComponent } from './pages/authenticate/email-verified.component';
import { FulfillmentComponent } from './pages/order/fulfillment.component';
import { PurchaseComponent } from './pages/order/purchase.component';
import { CheckoutComponent } from './pages/order/checkout.component';
import { ManageListingComponent } from './pages/manage-listing/manage.listing.component';
import { DisplayListingsPageComponent } from './pages/listing/display-listing.page.component';
import { CartPageComponent } from './pages/order/cart.page.component';
import { RegisterYourInterestComponent } from './pages/marketing/register-your-interest.component';
import { AboutUsComponent } from './pages/systemPages/about-us';
import { TestPageComponent } from './pages/systemPages/test-page.component';
import { RefundsAndReturnsComponent } from './pages/systemPages/refunds-and-returns';
import { ResetPasswordComponent } from './pages/systemPages/reset-password';
import { ManageProfileDetailsPageComponent } from './pages/account/manage-profile-details.page';
import { ProfileListingsComponent } from './pages/listing/profile-listings.component';
import { DigitalMaterialComponent } from './pages/order/digital-material.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'register-your-interest', component: RegisterYourInterestComponent },
  { path: 'email-verified', component: EmailVerifiedComponent, data:{isSystemPage: true} },
  { path: 'listings', redirectTo: 'listing', pathMatch: 'full' },
  { path: 'listing/search', component: SearchComponent, canActivate: [mixedGuard] },
  { path: 'listing/details/:listingId', component: DisplayListingsPageComponent, canActivate: [appGuard] },
  { path: 'listing', component: SearchComponent, canActivate: [appGuard] },
  { path: 'order/cart', component: CartPageComponent, canActivate: [appGuard] },
  { path: 'order/checkout', component: CheckoutComponent, canActivate: [appGuard] },
  { path: 'order/fulfillment', component: FulfillmentComponent, canActivate: [appGuard] },
  { path: 'order/fulfillment/:orderId', component: FulfillmentComponent, canActivate: [appGuard] },
  { path: 'order/purchase', component: PurchaseComponent, canActivate: [appGuard] },
  { path: 'order/purchase/:orderId', component: PurchaseComponent, canActivate: [appGuard] },
  { path: 'order/digital-material', component: DigitalMaterialComponent, canActivate: [appGuard] },
  { path: 'order/digital-material/:fulfillmentId', component: DigitalMaterialComponent, canActivate: [appGuard] },
  { path: 'order', component: CartPageComponent, canActivate: [appGuard] },
  { path: 'profile/details', component: ManageProfileDetailsPageComponent, canActivate: [appGuard] },
  { path: 'profile/listings', component: ProfileListingsComponent, canActivate: [appGuard] },
  { path: 'profile/listings/:locationId', component: ProfileListingsComponent, canActivate: [mixedGuard] },
  { path: 'account/manage', component: ManageAccountPageComponent, canActivate: [appGuard]},
  { path: 'account/manage/users', component: ManageUsersComponent, canActivate: [appGuard]},
  { path: 'location/details', component: ManageAccountPageComponent, canActivate: [appGuard]},
  { path: 'location/details/onboarding/:type', component: ManageAccountPageComponent, canActivate: [appGuard] },
  { path: 'invite', component: ManageUsersComponent, canActivate: [appGuard], data: {isInvitePage: true}},
  { path: 'login', component: AuthenticateComponent},
  { path: '_/auth/action', component: ResetPasswordComponent},
  { path: 'login/:email', component: AuthenticateComponent},
  { path: 'signup', component: AuthenticateComponent, data:{signup: true}},
  { path: 'logout', component: AuthenticateComponent},
  { path: 'post-a-new-listing', redirectTo: '/manage-listing/photos/new', pathMatch: 'full' },
  { path: 'manage-listing', component: ManageListingComponent, canActivate: [appGuard],
    children: [
      { path: 'photos/:listingId', component: PhotosComponent, canActivate: [appGuard]},
      { path: 'details/:listingId', component: DetailsComponent, canActivate: [appGuard]},
      { path: 'price-stock/:listingId', component: PriceStockComponent, canActivate: [appGuard]},
      { path: 'delivery/:listingId', component: DeliveryComponent, canActivate: [appGuard]},
      { path: 'status/:listingId', component: StatusComponent, canActivate: [appGuard]},
    ]
  },
  { path: 'about-us', component: AboutUsComponent},
  { path: 'terms-of-service', component: TermsOfServicesComponent},
  { path: 'privacy-policy', component: PrivacyPolicyComponent},
  { path: 'refunds-and-returns', component: RefundsAndReturnsComponent },
  { path: 'test-page', component: TestPageComponent},
];